module.exports = __webpack_public_path__ + "img/servipag.c1d5ca15.svg";